<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="overview" @selected="switchTab"></TabsWidget>
      <div class="tab-options">
        <b-select v-model="selected_currency" @input="onCurrencyChange" class="filter-currency-input"
          placeholder="Select Currency">
          <option value="RWF">RWF</option>
          <option value="USD">USD</option>
        </b-select>
      </div>
    </div>
    <div class="wrapper-body">
      <div class="balance-widget">
        <widgetCounter title="AVAILABLE BALANCE" :value="$formatMoney(
          available_balance,
          (decimalCount = 2),
          (decimal = '.'),
          (thousands = ','),
          (currency = selected_currency)
        )
          ">
          <img src="@/assets/images/dashboard/Graph-1.svg" />
        </widgetCounter>

        <widgetCounter title="TAX AMOUNT" :value="$formatMoney(
          tax_balance,
          (decimalCount = 2),
          (decimal = '.'),
          (thousands = ','),
          (currency = selected_currency)
        )
          ">
          <img src="@/assets/images/dashboard/Graph-3.svg" />
        </widgetCounter>
        <widgetCounter title="SETTLED BALANCE" :value="$formatMoney(
          settled_balance,
          (decimalCount = 2),
          (decimal = '.'),
          (thousands = ','),
          (currency = selected_currency)
        )
          ">
          <img src="@/assets/images/dashboard/Graph-4.svg" />
        </widgetCounter>
      </div>
      <div class="income-widget">
        <div class="income-widget-header">
          {{ moment().format("YYYY") }}: INCOME REPORT
        </div>
        <div class="income-widget-body">
          <apexchart type="bar" height="100%" width="100%" :options="chartOptions" :series="series" ref="incomeChart">
          </apexchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabsWidget from "./components/TabsWidget.vue";
export default {
  components: {
    TabsWidget,
  },
  sockets: {},
  data: () => ({
    loading_data: false,
    series: [
      {
        name: "Income",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
    chartOptions: {
      colors: ["#1a191b"],
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      yaxis: {
        title: {
          text: "RWF",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "FWR " + val;
          },
        },
      },
    },
    available_balance: 0,
    subscriptions_balance: 0,
    stream_balance: 0,
    voting_balance: 0,
    tax_balance: 0,
    settled_balance: 0,
    selected_currency: "RWF",
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getFundsOverview();
  },
  methods: {
    onCurrencyChange() {
      let vm = this;
      vm.getFundsOverview();
    },
    getFundsOverview() {
      let vm = this;
      vm.loading_data = true;
      vm.$store
        .dispatch("ADMIN_USER_FUNDS_OVERVIEW", {
          currency: vm.selected_currency,
        })
        .then((response) => {
          vm.loading_data = false;
          vm.available_balance = response.data.return.available_balance;
          vm.subscriptions_balance = response.data.return.subscription_balance;
          vm.stream_balance = response.data.return.streaming_balance;
          vm.tax_balance = response.data.return.tax_balance;
          vm.settled_balance = response.data.return.settlement_balance;
          vm.voting_balance = response.data.return.voting_balance;
          vm.$refs.incomeChart.updateSeries(
            [
              {
                data: response.data.return.income_in_year.map((item) => parseInt(item)),
              },
            ],
            false,
            true
          );
          // update option of  yaxis title text
          vm.$refs.incomeChart.updateOptions({
            yaxis: {
              title: {
                text: vm.selected_currency,
              },
            },
          });
        })
        .catch(({ response }) => {
          vm.loading_data = false;
        });
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./styles/mobile-panel.scss";

.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;
  @include dashboard-overview-mobile;

  .wrapper-header {
    width: 100%;
    height: 60px;
    padding: 0 10px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        white-space: nowrap;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: flex;
    flex-direction: column;

    @media (max-width: 650px) {
      overflow-y: auto;
    }

    .balance-widget {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 10px;
      padding: 10px;
      width: 100%;
      height: 130px;

      @media (max-width: 1180px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 650px) {
        height: unset;
      }

      @media (max-width: 596px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }

    .income-widget {
      display: flex;
      height: calc(100% - 130px);
      width: 100%;
      flex-direction: column;
      margin: 0 !important;

      @media (max-width: 650px) {
        height: unset;
      }

      .income-widget-header {
        font-size: 20px;
        padding: 0px 20px;
        height: 60px;
        margin: 10px 0;
        display: flex;
        align-items: center;
      }

      .income-widget-body {
        padding: 0px 20px;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: column;
        padding-bottom: 20px;
      }
    }
  }
}
</style>